import React from 'react';

import { type OtpFormProps, SentOtpForm } from './utilities';

/**
 * Convenience wrapper for email-based {@link SentOtpForm}.
 */
export default function EmailOtpForm({
  onSuccess: handleSuccess,
  onFailure: handleFailure,
  isCodeReadyForSubmission,
  onSubmittableChange: handleSubmittableChange,
}: OtpFormProps) {
  return (
    <SentOtpForm
      isCodeReadyForSubmission={isCodeReadyForSubmission}
      sentFactorType='email'
      onSuccess={handleSuccess}
      onFailure={handleFailure}
      onSubmittableChange={handleSubmittableChange}
    />
  );
}
